import '../DailyForm/dailyForm.scss';
import '../MonthlyForm/monthlyForm.scss';

import { format } from 'date-fns';
import * as React from 'react';
import { connect } from 'react-redux';
import { actions } from 'react-redux-form';
import { withRouter } from 'react-router';
import { toast } from 'react-toastify';
import * as PropTypes from 'prop-types'; 

import { SIGNATURE_ERROR } from '../../../constants/generals';
import { IHistory } from '../../../interfaces';
import { QuestionModel } from '../../../model/QuestionModel';
import { uploadImages } from '../../../services/formService';
import { parseJwt } from '../../../services/loginService';
import { submitQuarterlyForm, getQuarterlyFormQuestions } from '../../../services/quarterlyFormService';
import { dispatch, marshallAnswers, getPageTitle } from '../../../utils/generalUtils';
import { Async } from '../../reusableComponents/Async';
import { BasePage } from '../../reusableComponents/BasePage';
import { CustomSignaturePad } from '../../reusableComponents/CustomSignaturePad';
import { ErrorPage } from '../../reusableComponents/ErrorPage';
import { Form } from '../../reusableComponents/FormComponents/Form';
import { FormFooter } from '../../reusableComponents/FormComponents/FormFooter';
import { ImageUpload } from '../../reusableComponents/ImageUpload';
import { Loader } from '../../reusableComponents/Loader';
import { ShopInspection } from '../../../constants/generals';
import { RenderQuestion } from '../../reusableComponents/FormComponents/RenderQuestion';
import { QuarterlyFormModel } from '../../../model/QuarterlyFormModel';

export interface IShopInspectionFormProps {
    questions: QuestionModel[];
    type: string;
    date: string;
    plantId: string;
    userUID: string;
    userName: string;
    history: IHistory;
    formId: string;
    formInstance: QuarterlyFormModel;
    form;
}

export interface IShopInspectionFormState {
    date: string;
}

export class ShopInspectionFormImpl extends React.PureComponent<IShopInspectionFormProps, IShopInspectionFormState> {
    constructor(props: IShopInspectionFormProps) {
        super(props);
        this.state = {
            date: props.date
        };
    }

    promise = async () => {
        await getQuarterlyFormQuestions(this.props.type, this.props.formId);
    }

    refs: {
        images: ImageUpload;
        signatureInput: CustomSignaturePad;
    };
    getChildContext() {
        return { formModel: 'forms.shopInspectionForm' };
    } 

    static childContextTypes = {
        formModel: PropTypes.string
    };
    handleFormSubmit = async (values) => {
        if (!this.refs.signatureInput.signature) {
            toast.error(SIGNATURE_ERROR, {
                position: toast.POSITION.TOP_CENTER,
                className: 'failed-toast'
            });
            return;
        }
        //const signatureURL = await uploadImages([this.refs.signatureInput.signature], 'signatures');
        const answer = marshallAnswers(values);
        const data = {
            UserId: this.props.userUID,
            PlantId: this.props.plantId,
            InspectionID: 'ShopInspection',
            followUp_Required: false,
            Completed: true,
            Date: format(new Date(this.props.date), 'MM-DD-YYYY'),
            Answers: answer,
            followUp_form: 0,
            ImageUrls: [],
            DeletedImages : this.props.form.shopInspectionForm.deletedImages || [],
            SignatureUrls: '',
            AssociatedTo: null,
            SignatureData: this.refs.signatureInput.signature, 
        };
        return submitQuarterlyForm(data, this.props.history, this.refs.images.value, this.props.formId);
    }

    loadValues = () => {
        this.props.questions.forEach(instance => {
            if (instance.props.answer) {
                dispatch(actions.change(`forms.shopInspectionForm.${instance.props.quesNum}`, instance.props.answer));
            }
        });
        dispatch(actions.change(`forms.shopInspectionForm.28`, format(new Date(), 'hh:mm A')));
    }

    renderContent = () => {
        const Buttons = [{
            label: 'Yes',
            value: 'Yes'
        },
        {
            label: 'No',
            value: 'No'
        },
        {
            label: 'N/A',
            value: 'N/A'
        }
        ];
        return <Form
            model="forms.shopInspectionForm"
            onSubmit={this.handleFormSubmit}
            className="form"
            loadDefaultValues={this.loadValues}
        >
            {ShopInspection && ShopInspection.map((quesData, index) => (
                <RenderQuestion
                    formId={this.props.formId}
                    key={index}
                    uniqueValue={index}
                    quesNo={quesData.Question_Num && quesData.Question_Num.toString()}
                    question={quesData.Question}
                    questionType={quesData.Questiontype}
                    model="shopInspectionForm"
                    CommentQuestionNum={quesData.CommentQuestionNum ? quesData.CommentQuestionNum : null}
                    customLabel={quesData.customLabel && quesData.customLabel}
                    buttons={Buttons}
                    isCheck={true}
                />
            ))
            }
            <div style={{ padding: '45px', fontSize: '18px' }} >
                I certify under penalty of law that this document and all attachments were
    prepared under my direction or supervision in accordance with a system designed to
    assure that qualified personnel properly gathered and evaluated the information
    submitted. Based on my inquiry of the person or persons who manage the system, or those
    persons directly responsible for gathering the information, the information submitted
    is, to the best of my knowledge and belief, true, accurate, and complete. I am
    aware that there are significant penalties for submitting false information,
    including the possibility of fine and imprisonment for knowing violations.
            </div>
            <div className="image-signature-container" >
                <ImageUpload
                    ref="images"
                    multi={true}
                    label="Select Images to Upload:"
                    defaultValue={this.props.formInstance && this.props.formInstance.props.ImageUrls }
                />
                <CustomSignaturePad ref="signatureInput" userName={this.props.userName} />
            </div>
            <FormFooter />
        </Form>;
    }

    render() {
        let day = this.props.date, cdate = new Date(day);
        let month = cdate.getMonth() + 1;
        let year = cdate.getFullYear();
        let qtr = '';
        if (month <= 3) {
            qtr = '1st';
        } else if (month > 3 && month <= 6) {
            qtr = '2nd';
        } else if (month > 6 && month <= 9) {
            qtr = '3rd';
        } else {
            qtr = '4th';
        } 
        let title = `${getPageTitle(this.props.type, 'quarterly', this.props.date, 'inspection')} `;
        return <BasePage pageTitle={title/* `Shop Inspection Form for ${qtr} Quarter of ${year}` */}>
            <Async
                identifier="ShopInspectionForm"
                promise={this.promise}
                loader={<Loader type="async" />}
                content={this.renderContent()}
                error={<ErrorPage />}
            />
        </BasePage>;
    }

}
export function mapStateToProps(state, ownProps) {
    const type = 'ShopInspection';
    const date = ownProps.match.params.date;
    const questions = QuestionModel.getAllByType(type);
    const userName = parseJwt(state.login.get('token')).First_Name;
    const formInstance = QuarterlyFormModel.get(ownProps.match.params.formId); 
    return {
        plantId: ownProps.match.params.plantId,
        userUID: state.login.get('UniqueId'),
        type, questions, date, userName,
        formId: ownProps.match.params.formId,form: state.forms, formInstance
    };
}
export const ShopInspectionForm =
    withRouter(connect<{}, {}, IShopInspectionFormProps>(mapStateToProps)(ShopInspectionFormImpl as any));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Forms/QuarterlyForm/ShopInspectionForm.tsx